import {useRef, useState, useEffect} from "react";
import PropTypes from "prop-types";

const PLACEHOLDER_HEIGHT = 352; // theme.spacing(44)

const LazyListCard = ({children, rootMargin = "200px"}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {rootMargin},
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return visible ? children : <div ref={ref} style={{minHeight: PLACEHOLDER_HEIGHT}} />;
};

LazyListCard.propTypes = {
  children: PropTypes.node.isRequired,
  rootMargin: PropTypes.string,
};

export default LazyListCard;
